import { formatter } from "@ruter-as/web-components-and-tools";
import { addMonths, differenceInCalendarDays, startOfMonth } from "date-fns";

const getChangeDates = (): string[] => {
	let firstInThisMonth = startOfMonth(new Date());
	if (differenceInCalendarDays(new Date(), firstInThisMonth) >= 0) {
		firstInThisMonth = addMonths(firstInThisMonth, 1);
	}

	const output = [formatter.date.toShortDateString(firstInThisMonth)];
	const numberOfOptions = 3;

	for (let i = 1; i < numberOfOptions; i += 1) {
		output.push(
			formatter.date.toShortDateString(addMonths(firstInThisMonth, i)),
		);
	}
	return output;
};

export default getChangeDates;
